module.exports = __webpack_public_path__ + "img/201.d2476c5b.jpg";